import { InfoIcon } from "@/components/icons/info-icon";
import { TextButton } from "@/components/ui/buttons";
import { useOpenWeeklyBalanceCoach } from "@/features/overview/hooks/use-open-weekly-balance-coach";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { IonSkeletonText } from "@ionic/react";
import { memo } from "react";
import { ProgressBarTrack, ProgressBreakpoints, SegmentMaxPercentages } from "./progress-bar-track";

const RANGE_LABELS = ["Under plan", "On Plan", "Over plan"] as const;
const formatScaleValue = (value: number) => (value > 0 ? `+${value}` : `${value}`);

interface OnPlanProgressBarProps {
  value: number;
  breakpoints: ProgressBreakpoints;
  isLoading?: boolean;
  segmentMaxPercentages?: SegmentMaxPercentages;
}

export const OnPlanProgressBar = memo(function OnPlanProgressBar({
  value,
  breakpoints,
  isLoading = false,
  segmentMaxPercentages,
}: OnPlanProgressBarProps) {
  const openWeeklyBalanceCoach = useOpenWeeklyBalanceCoach("on-plan");
  const [, low, , high] = breakpoints;

  if (isLoading) {
    return (
      <div className="mt-2 w-full text-left">
        <IonSkeletonText animated className="h-21 w-full rounded-2xl" />
      </div>
    );
  }

  return (
    <div className="mt-2 w-full text-left">
      <div className="grid grid-cols-3">
        {RANGE_LABELS.map((label, index) => {
          return (
            <p
              key={label}
              className={cn(textVariants.footnote, "text-white", {
                "text-center": index !== 0 && index !== RANGE_LABELS.length - 1,
                "text-left": index === 0,
                "text-right": index === RANGE_LABELS.length - 1,
              })}
            >
              {label}
            </p>
          );
        })}
      </div>

      <ProgressBarTrack
        breakpoints={breakpoints}
        value={value}
        segmentMaxPercentages={segmentMaxPercentages}
      />

      <div className="mt-2 grid grid-cols-5 px-1">
        {/* <span className={cn(textVariants.footnote, "text-left text-white/70")}>
          {formatScaleValue(min)}kcal
        </span> */}
        <span />
        <span className={cn(textVariants.footnote, "text-center text-white")}>
          {formatScaleValue(low)}
        </span>
        <TextButton
          className="mx-auto flex h-6 w-6 items-center justify-center !py-0"
          aria-label="Weekly calorie balance information"
          onClick={openWeeklyBalanceCoach}
        >
          <InfoIcon className="fill-white" />
        </TextButton>
        <span className={cn(textVariants.footnote, "text-center text-white")}>
          {formatScaleValue(high)}
        </span>
        {/* <span className={cn(textVariants.footnote, "text-right text-white/70")}>
          {formatScaleValue(max)} kcal
        </span> */}
        <span />
      </div>
    </div>
  );
});
